/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Speaker_Filters_LabelInputs */

const en_editor_speaker_filters_label = /** @type {(inputs: Editor_Speaker_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker filters`)
};

const fr_editor_speaker_filters_label = /** @type {(inputs: Editor_Speaker_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtres de locuteurs`)
};

const de_editor_speaker_filters_label = /** @type {(inputs: Editor_Speaker_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautsprecherfilter`)
};

const it_editor_speaker_filters_label = /** @type {(inputs: Editor_Speaker_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtri per altoparlanti`)
};

const ru_editor_speaker_filters_label = /** @type {(inputs: Editor_Speaker_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтры динамиков`)
};

const es_editor_speaker_filters_label = /** @type {(inputs: Editor_Speaker_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros de altavoz`)
};

const zh_cn2_editor_speaker_filters_label = /** @type {(inputs: Editor_Speaker_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扬声器滤波器`)
};

const ja_editor_speaker_filters_label = /** @type {(inputs: Editor_Speaker_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーフィルター`)
};

const hi_editor_speaker_filters_label = /** @type {(inputs: Editor_Speaker_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर फ़िल्टर`)
};

const pt_pt2_editor_speaker_filters_label = /** @type {(inputs: Editor_Speaker_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros de alto-falante`)
};

/**
* | output |
* | --- |
* | "Speaker filters" |
*
* @param {Editor_Speaker_Filters_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_speaker_filters_label = /** @type {((inputs?: Editor_Speaker_Filters_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Speaker_Filters_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_speaker_filters_label(inputs)
	if (locale === "de") return de_editor_speaker_filters_label(inputs)
	if (locale === "it") return it_editor_speaker_filters_label(inputs)
	if (locale === "ru") return ru_editor_speaker_filters_label(inputs)
	if (locale === "es") return es_editor_speaker_filters_label(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_speaker_filters_label(inputs)
	if (locale === "ja") return ja_editor_speaker_filters_label(inputs)
	if (locale === "hi") return hi_editor_speaker_filters_label(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_speaker_filters_label(inputs)
	return en_editor_speaker_filters_label(inputs)
});